export default {
  svgPath: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.00012 11C1.00004 11 1 11 1 10C1 9 1.00004 9 1.00012 9L19 9L19 11L1.00012 11Z"/>
  `,
  title: 'Minus',
  viewBox: '0 0 21 20',
};

